import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';
import { getVisitorToken } from '../../../helpers/cookies/getVisitorToken';

const GetLastVisitedQuery = gql`
  query($userToken: String!, $without: String, $limit: Int, $time: String, $country: String) {
    lastVisited(userToken: $userToken, without: $without, limit: $limit, time: $time, country: $country) {
      userToken
      variant {
        id
        ean
        sku
        definition
        price
        recommendedPrice
        prices
        inStock
        product {
          id
          name
          slug
          price
          prices
          recommendedPrice
          tags
          description
          sku
          display
          status
          weight
          weightForShipping
          visibleForCustomerGroup
          images {
            id
            file
            priority
          }
        }
      }
    }
    productTags {
      id
      name
      title
      slug
      color
      active
    }
  }
`;

interface IInputProps {
  children?: any;
  userToken: string;
  without?: string;
  country?: string;
  limit?: number;
}

interface IResponse {
  data: any;
}

class LastVisitedQuery extends React.PureComponent<ChildProps<IInputProps, IResponse>> {
  public render() {
    const lastVisited = (this.props as any).lastVisited;
    return this.props.children({
      lastVisited,
    });
  }
}

export default compose(
  graphql<IInputProps, IResponse>(GetLastVisitedQuery, {
    name: 'lastVisited',
    options: props => ({
      variables: {
        userToken: getVisitorToken(),
        without: props.without,
        country: props.country,
        limit: props.limit,
      },
      option: {
        fetchPolice: 'cache-and-network',
      },
    }),
  }),
)(LastVisitedQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Products/LastVisited.tsx